<script lang="ts" setup>
import type {Component} from "#magnolia-layer/types/magnolia-types";

const props = defineProps<{
  metadata: Component;
  title: string;
  subTitle?: string;
  value: string;
  unit: string;
}>();

const amountOfSiblings = inject<number>("amountOfSiblings");
const computedClass = computed(() => {
  if (amountOfSiblings === 1) {
    return "col-start-7 col-span-7 lg:mx-12 p-12";
  } else {
    let result = "col-span-4 p-6";
    if (amountOfSiblings === 2 && props.metadata["@index"] === 0) {
      result += " col-start-5";
    }
    return result;
  }
});

const computedTitleClass = computed(() => {
  if (amountOfSiblings === 1) {
    return "text-4xl";
  }
  return "text-3xl";
});
</script>

<template>
  <div
    :class="computedClass"
    class="measurement bg-neutral-100 flex flex-col justify-between col-custom min-h-75">
    <div class="measurement__header mb-8">
      <h2 :class="computedTitleClass" class="font-sans font-bold">
        {{ title }}
      </h2>
      <span v-if="subTitle" class="text-xl font-sans mt-2 inline-block">{{
        subTitle
      }}</span>
    </div>
    <div class="measurement__body">
      <span class="text-7xl font-sans font-bold tabular-nums">{{ value }}</span>
      <span class="font-sans text-xl ml-2 mb-2">{{ unit }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
